(function () {
  'use strict';
  function initialize() {
    document.querySelectorAll('[data-jei-cartridge-calculator]').forEach(function (root) {
      if (root.dataset.jeiInitialized === 'true') return;
      root.dataset.jeiInitialized = 'true';
      function field(name) { return root.querySelector('[data-jei="' + name + '"]'); }
      var capacities = { standard: 139200, small: 35200 };
      function update(event) {
        if (event && event.target === field('hardness-range')) field('hardness').value = event.target.value;
        if (event && event.target === field('drinks-range')) field('drinks').value = event.target.value;
        var hardnessText = field('hardness').value.trim();
        var drinksText = field('drinks').value.trim();
        var hardness = Number(hardnessText);
        var drinks = Number(drinksText);
        var filter = field('filter').value;
        var valid = hardnessText !== '' && drinksText !== '' &&
          Number.isFinite(hardness) && hardness >= 0 && hardness <= 25 &&
          Number.isFinite(drinks) && drinks >= 0 && drinks <= 400 && Number.isInteger(drinks) &&
          Object.prototype.hasOwnProperty.call(capacities, filter);
        field('error').hidden = valid;
        if (!valid) {
          field('result').textContent = '—';
          field('detail').textContent = 'Check your inputs.';
          return;
        }
        field('hardness-range').value = hardness;
        field('drinks-range').value = drinks;
        if (drinks === 0) {
          field('result').textContent = 'No usage estimate';
          field('detail').textContent = 'Enter daily drink volume to estimate cartridge life.';
        } else if (hardness <= 3) {
          field('result').textContent = 'No hardness-based limit';
          field('detail').textContent = 'Follow the filter manufacturer’s time-based replacement guidance.';
        } else {
          var days = Math.round(capacities[filter] / ((hardness - 3) * drinks));
          field('result').textContent = days.toLocaleString() + ' days';
          field('detail').textContent = 'Based on hardness and drink volume.';
        }
      }
      root.addEventListener('input', update);
      root.addEventListener('change', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
